exports.polyfill = function (Component) {
  return Component;
};